import EN from "./utils/lang/en.json";
import TR from "./utils/lang/tr.json";

export const languages = [
    { name: 'English', value: 'en' },
    { name: 'Turkish', value: 'tr' },
];


export const translations = {
    en: EN,
    tr: TR,
};
